// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { CreateQuote, UpdateQuote } from "../../actions/quoteActions";
import { LoadingProgress } from "imagus-components";
import CreateQuoteForm from "../../components/quotes/CreateQuoteForm";

type CreateQuoteFormReduxPropsType = {
  onClose: Function,
  companyType: string,
  companyAuthority: boolean,
  quote?: { [key: string]: * },
  isAdmin?: boolean,
  companies: Array<*>,
  adminCompanies: Array<*>,
  priceSheet: { [key: string]: * },
  productSheet: { [key: string]: * },
  adminProductSheets: Array<*>,
  sheetCompanies: Array<*>,
  actions: {
    CreateQuote: Function,
    UpdateQuote: Function
  }
};

class CreateQuoteFormRedux extends Component<CreateQuoteFormReduxPropsType, *> {
  createQuote = (
    retailSum: number,
    resellerSum: number,
    distributerSum: number,
    authorisedReseller: boolean,
    licenceType: string,
    parts: Array<*>,
    companyName: string,
    companyId: string,
    tierId: string,
    productSheetId: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.CreateQuote(
      retailSum,
      resellerSum,
      distributerSum,
      authorisedReseller,
      licenceType,
      parts,
      companyName,
      companyId,
      tierId,
      productSheetId,
      doneCallback,
      failCallBack
    );
  };

  editQuote = (
    quoteId: string,
    retailSum: number,
    resellerSum: number,
    distributerSum: number,
    authorisedReseller: boolean,
    parts: Array<*>,
    companyName: string,
    companyId: string,
    tierId: string,
    productSheetId: string,
    doneCallback: Function,
    failCallBack: Function,
    isAdmin?: boolean
  ): * => {
    this.props.actions.UpdateQuote(
      quoteId,
      retailSum,
      resellerSum,
      distributerSum,
      authorisedReseller,
      parts,
      companyName,
      companyId,
      tierId,
      productSheetId,
      doneCallback,
      failCallBack,
      isAdmin
    );
  };

  render(): React$Element<*> {
    let companies;
    let productSheet;
    if (this.props.isAdmin) {
      companies =
        this.props.adminCompanies &&
        this.props.quote &&
        this.props.adminCompanies[this.props.quote.createdCompanyId];

      const thisCompany =
        this.props.quote && this.props.quote.createdCompanyUid;
      let sheetId;
      this.props.sheetCompanies &&
        this.props.sheetCompanies.forEach((sheet: *) => {
          let index = sheet.companies.edges.findIndex(
            (company: *): boolean => company.node.uuid === thisCompany
          );
          if (index > -1) {
            sheetId = sheet.id;
          }
        });

      if (sheetId) {
        let sheetIndex =
          this.props.adminProductSheets &&
          this.props.adminProductSheets.findIndex(
            (sheet: *): boolean => sheet.id === sheetId
          );
        if (sheetIndex > -1) {
          productSheet = this.props.adminProductSheets[sheetIndex];
        }
      }
    } else {
      companies = this.props.companies && [...this.props.companies];
      productSheet = this.props.productSheet;
    }

    if (companies) {
      return (
        <CreateQuoteForm
          onClose={this.props.onClose}
          companyType={this.props.companyType}
          quote={this.props.quote}
          isAdmin={this.props.isAdmin}
          companies={companies}
          priceSheet={this.props.priceSheet}
          companyAuthority={this.props.companyAuthority}
          productSheet={productSheet}
          createQuote={this.createQuote}
          editQuote={this.editQuote}
        />
      );
    } else {
      return <LoadingProgress />;
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  priceSheet: state.v3account.quote.priceSheet,
  productSheet: state.v3account.quote.productSheet,
  adminProductSheets: state.v3admin.quote.productSheets,
  companies: state.v3account.quote.companies,
  adminCompanies: state.v3admin.quote.companies,
  sheetCompanies: state.v3admin.quote.sheetCompanies
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ CreateQuote, UpdateQuote }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateQuoteFormRedux);
